import { useCallback, useContext } from 'react'

import { getValueAsArray } from '@hap/analytics'

import { AVAILABLE_FILTERS } from './constants'
import { FilterContext } from './filter-context'

export function useFilterMutator<V extends string>() {
  const { filter, field, onSelect } = useContext(FilterContext)
  const values = getValueAsArray(filter)

  const handleSelect = useCallback(
    (newValues: string[]) => {
      if (!field) return
      const filterConfig = AVAILABLE_FILTERS[field]
      const dataset = filterConfig ? filterConfig.dataset : undefined

      if (!filter) {
        onSelect({
          op: 'in',
          field: field,
          values: newValues,
          dataset,
        })
      } else {
        const op = filter.op
        if (op !== 'in' && op !== 'nin')
          throw new Error('Invalid filter op. filter: ' + JSON.stringify(filter))
        onSelect({
          op: op,
          field: field,
          values: newValues,
          dataset,
        })
      }
    },
    [field, filter, onSelect],
  )

  return {
    selection: values as V[],
    onSelect: handleSelect,
  }
}
